import { useEffect } from "react";
import { useSetRecoilState } from "recoil";
import { authReadyState, authState } from "./authAtom";
import { invalidateExpiredSession, refreshSession } from "../utils/api";
import { normalizeAuthIdentity, normalizeSessionType } from "../utils/auth";

const AuthProvider = ({ children }) => {
  const setAuth = useSetRecoilState(authState);
  const setAuthReady = useSetRecoilState(authReadyState);

  useEffect(() => {
    let mounted = true;

    const restoreSession = async () => {
      try {
        const response = await refreshSession();
        if (!mounted) return;
        if (!response) invalidateExpiredSession();
        const identity =
          response?.user ||
          response?.org ||
          response?.centre ||
          response?.doctor ||
          response?.data?.user ||
          response?.data?.org ||
          response?.data?.centre ||
          response?.data?.doctor;
        const sessionType =
          response?.sessionType ||
          response?.data?.sessionType ||
          (response?.doctor || response?.data?.doctor ? "doctor" : null) ||
          (response?.user || response?.data?.user ? "user" : null) ||
          (response?.org || response?.data?.org ? "org" : null) ||
          (response?.centre || response?.data?.centre ? "centre" : null);

        // The cookie is the authority; this object is only safe UI data such as
        // name and permissions. A successful refresh without identity still
        // permits session routing, but cannot render permission-based controls.
        setAuth(
          identity
            ? normalizeAuthIdentity(identity, sessionType)
            : response?.success
              ? {
                  authenticated: true,
                  permissions: {},
                  sessionType: normalizeSessionType(
                    response?.sessionType || response?.data?.sessionType,
                  ),
                }
              : null,
        );
      } catch {
        invalidateExpiredSession();
        if (mounted) setAuth(null);
      } finally {
        if (mounted) setAuthReady(true);
      }
    };

    restoreSession();
    return () => {
      mounted = false;
    };
  }, [setAuth, setAuthReady]);

  return children;
};

export default AuthProvider;
